// extracted by mini-css-extract-plugin
export default {"collapsibleTitle":"collapsibleTitle-efe5","format-icon":"format-icon-d7cf","generalIcons":"generalIcons-aa6c","float-left":"float-left-4dcd"};